import * as React from "react";
import styled from "styled-components";
import { useAuth } from '../../contexts/AuthContext';
import { usePrivacy } from '../../contexts/PrivacyContext';
import PopupCard from "./PopupCard";

const UserAvatar = ({ initials, backgroundColor, isVisible }) => (
    <AvatarCircle $backgroundColor={backgroundColor} $isVisible={isVisible}>
        {initials}
    </AvatarCircle>
);

const SessionList = ({ session }) => {
    const { groupMembers } = useAuth();
    const { maskInitial } = usePrivacy();
    const [showPopup, setShowPopup] = React.useState(false);

    const handleTitleClick = () => {
        setShowPopup(prev => !prev); // Toggle popup visibility
    };

    return (
        <UserListWrapper>
            <UserItem>
                <ContributorsWrapper>
                    {groupMembers.map((user, index) => {
                        const isContributor = session.contributors.some(contributor =>
                            contributor.email === user.email
                        );
                        return (
                            <UserAvatar
                                key={index}
                                initials={maskInitial(user.name) || user.initial}
                                backgroundColor={user.color || '#cccccc'}
                                isVisible={isContributor}
                            />
                        );
                    })}
                </ContributorsWrapper>
                <ClickableTitle onClick={handleTitleClick}>
                    {session.title}
                </ClickableTitle>
            </UserItem>
            {showPopup && 
                <PopupCardWrapper>

                    <PopupCard session={session} />
                </PopupCardWrapper>
            }
        </UserListWrapper>
    );
};

const UserListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start; 
    gap: 6px;
    padding-bottom: 5px;
    margin-left: 8px;
    margin-right: 8px;
`;

const UserItem = styled.div`
    display: flex;
    width: 100%;   
    justify-content: flex-start; 
    align-items: center;        /* vertical centering in the row */
    text-align: left;  
`;

const ContributorsWrapper = styled.div`
    display: flex;
    gap: 3px;
    margin-right: 8px;
`;

const ClickableTitle = styled.div`
    color: #969a97;
    font: 500 18px Inter, sans-serif;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    &:hover {
        color: #9333ea;
        text-decoration: underline;
    }
`;

const AVATAR_SIZE = 24;

const AvatarCircle = styled.div`
    ont-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    display: inline-flex;
    align-items: center;
    line-height: 1;   
    position: relative;  
    justify-content: center;
    width: ${AVATAR_SIZE}px;
    height: ${AVATAR_SIZE}px;
    border-radius: 9999px;
    background-color: ${props => props.$backgroundColor};
    border: 1px solid ${props => props.$backgroundColor};         /* subtle, neutral border like a chip */
    color: #111827;
    font-size: 12px;                   /* balanced inside 20px circle */
    font-weight: 500;
    vertical-align: middle;            /* baseline-align with Tag */
    margin-right: 0;                   /* spacing controlled by gap above */
    transition: opacity .2s ease, visibility .2s ease, transform .15s ease, box-shadow .15s ease;
    opacity: ${props => props.$isVisible ? 1 : 0};
    visibility: ${props => props.$isVisible ? 'visible' : 'hidden'};
`;

const PopupCardWrapper = styled.div`
  width: 100%;
  align-self: stretch;       /* make popup as wide as the list area */
  margin-top: 8px;
`;

export default SessionList;
